import { Delete } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Box,
    Breadcrumbs,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useState, Fragment } from 'react';
// import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import "./send.css";
// import CheckCircleOutlined from "@mui/icons-material/CheckCircle";
import { Edit } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import CommonDialog from '../../../common/CommonDialog';
import { DETAIL_STATUS, DetailStatusChip } from '../../../common/DetailStatusChip';
import { deleteDraftEstimate, deleteFinalizedEstimate } from '../../../redux/Estimate/action';
import { estimateQueryKeys } from '../../../services/business/estimates/estimates.hooks';
import { INVENTORY_MANAGE_TYPE, INVENTORY_TYPES, MILEAGE_UNIT, PART_TYPES, PRICING_TYPES } from '../../../utility/Constant';
import PartBrandSvg from '../../../utility/Svg/PartBrandSvg';
import PartCategorySvg from '../../../utility/Svg/PartCategorySvg';
import AddInventoryModal from '../../Inventory/AddInventory';
import SuccessMessageModal from '../../Common/SuccessMessage';
import EstimateFeesTable from '../EstimateCommonComponents/EstimateFeesTable';
import EstimatePaymentDetails from '../EstimateCommonComponents/EstimatePaymentDetails';
import EstimateTermsAndWarranty from '../EstimateCommonComponents/EstimateTermsAndWarranty';

import { useQueryClient } from '@tanstack/react-query';
import LineTaxCell from '../../../common/Tax/LineTaxCell';
import { useGetShopConfig, useGetShopTaxes } from '../../../services/core/settings';
import { NumericEngine } from '../../../utility/helpers/numericEngine';
import { shouldShowPerServiceSubtotalRow } from '../../../utility/helpers/shouldShowPerServiceSubtotalRow';
import { DOCUMENT_TAX_TYPE, isNewTaxVersion, LINE_TAX_KIND, recordHasPartsOrPackages, recordPartGrossAmount } from '../../../utility/helpers/taxCalculation';
import { useProvinceTaxGroup } from '../../../utility/hooks/useProvinceTaxGroup';
import DetailPageHeaderInfoColumns from '../../Invoice/invoiceCommonComponents/DetailPageHeaderInfoColumns';
import InvoiceRecommandationSection from '../../Invoice/invoiceCommonComponents/InvoiceRecommandationSection';

const EstimateDraft = ({ estimateId, estimateData, showLoader, setShowLoader }) => {
    const provinceTaxGroup = useProvinceTaxGroup();
    const documentHasPartsOrPackages = recordHasPartsOrPackages(estimateData);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const [openSuccessModal, setOpenSuccessModal] = React.useState(false);
    const [selectedInventoryId, setSelectedInventoryId] = useState(null);
    const [batchNumber, setBatchNumber] = useState(null);
    const [openPartModel, setOpenpartModel] = useState(false);
    const [openBatchSelectionModal, setBatchSelectionModal] = useState(false);
    const [inventoryOption, setInventoryOption] = useState(null);
    const [successMessage, setSuccessMessage] = React.useState('');

    const [isDeleteModal, setIsDeleteModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);

    const { data: shopConfigData, isLoading: isConfigLoading, error: configError } = useGetShopConfig();
    const { data: shopTaxesData } = useGetShopTaxes();

    const showLineTax = isNewTaxVersion(estimateData);

    const mileageUnit = shopConfigData?.config?.mileageUnit === MILEAGE_UNIT.MILES ? MILEAGE_UNIT.MILES : MILEAGE_UNIT.KM;

    function handleClick(event) {
        event.preventDefault();
        console.info('You clicked a breadcrumb.');
    }

    const { id } = useParams();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const open1 = Boolean(anchorEl);

    const handleClick1 = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose1 = () => {
        setAnchorEl(null);
    };

    const handleDeleteDraft = async () => {
        setShowLoader(true);
        const data = await dispatch(deleteDraftEstimate(estimateId));
        if (data) {
            queryClient.invalidateQueries({ queryKey: estimateQueryKeys.all, refetchType: 'all' });
            navigate('/estimates/drafts');
        }
        setShowLoader(false);
    };

    const serviceSubtotalCache = new WeakMap();
    const selectServiceSubtotal = (service) => {
        if (!service) return '0';

        if (serviceSubtotalCache.has(service)) {
            return serviceSubtotalCache.get(service);
        }
        let subtotal = '0';

        // FIXED service pricing
        if (service.pricingType === PRICING_TYPES.FXIED) {
            subtotal = service.fixedPrice || '0';
        }

        // LABOUR & PARTS service pricing
        if (service.pricingType === PRICING_TYPES.LABOUR) {
            const laborAmount = service.labor?.totalAmount || '0';

            // qty × (cost + per-unit fee) — totalAmount is qty × cost only (see recordPartGrossAmount).
            const partsAmount = (service.parts || []).reduce((acc, part) => NumericEngine.add(acc, String(recordPartGrossAmount(part))), '0');

            subtotal = NumericEngine.add(laborAmount, partsAmount);
        }

        serviceSubtotalCache.set(service, subtotal);

        return subtotal;
    };

    return (
        <>
            <Box
                padding={'32px 24px'}
                sx={{
                    bgcolor: 'background.main',
                    width: 'fit-content',
                    minWidth: '100%',
                }}
            >
                {' '}
                <Grid container sx={{ padding: '16px 0px' }} gap={'8px'}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div role="presentation" onClick={handleClick}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    to="/estimates/all"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Estimates
                                </Link>
                                <Link
                                    to="/estimates/drafts"
                                    style={{
                                        color: 'black',
                                        opacity: '0.6',
                                        textDecoration: 'none',
                                    }}
                                >
                                    Draft
                                </Link>
                                <Link to="/estimates/all" style={{ color: 'black', textDecoration: 'none' }}>
                                    {estimateData && estimateData?.estimateNumber}
                                </Link>
                            </Breadcrumbs>
                        </div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography variant="h4" fontWeight={500}>
                            {estimateData && estimateData?.estimateNumber}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} justifyContent="end">
                    <Grid item>
                        <Stack direction={'row'} spacing={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<Edit />}
                                onClick={() => {
                                    navigate(`/estimates/edit/${id}`);
                                }}
                                size="large"
                            >
                                Edit Estimate
                            </Button>
                            {/* <Button variant="contained" onClick={handleOpen}>more actions</Button> */}

                            <Button
                                variant="contained"
                                color="greyColor"
                                id="demo-positioned-button"
                                aria-controls={open1 ? 'demo-positioned-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : undefined}
                                onClick={handleClick1}
                                size="large"
                                style={{
                                    width: '182px',
                                    fontWeight: 500,
                                    lineHeight: '24px',
                                    letterSpacing: '0.4px',
                                    fontSize: '14px',
                                    height: '42px',
                                    color: '#000000',
                                    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
                                }}
                            >
                                more actions
                                <ExpandMoreIcon style={{ marginLeft: '8px' }} />
                            </Button>

                            <Menu
                                style={{ top: 3 }}
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={open1}
                                onClose={handleClose1}
                                sx={{
                                    // MORE ACTIONS menu: the button's width, sitting directly under it.
                                    '& .MuiPaper-root': { width: '182px', minWidth: 'unset!important' },
                                    '& .MuiMenuItem-root': { padding: '6px 12px!important', width: '100%' },
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        navigate(`/customers/${estimateData?.customer?._id}/${estimateData?.customer?.createdFrom}`);
                                    }}
                                >
                                    <VisibilityIcon style={{ marginRight: '8px' }} />
                                    View Customer
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setIsDeleteModal(true);
                                        handleClose1();
                                    }}
                                    style={{ color: '#D32F2F!important' }}
                                >
                                    <Delete style={{ marginRight: '8px', color: '#D32F2F' }} /> <span style={{ color: '#D32F2F' }}> Delete Estimate </span>
                                </MenuItem>
                            </Menu>

                            {/* <Button
                                variant="contained"
                                color="error"
                                id="demo-positioned-button"
                                aria-controls={open1 ? 'demo-positioned-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={open1 ? 'true' : undefined}
                                // onClick={handleClick1}
                                onClick={() => {
                                    handleDeleteDraft();
                                }}
                                size="large"
                            >
                                <DeleteIcon style={{ marginRight: '10px' }} /> Delete Draft
                            </Button> */}
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container padding={'32px'} margin={'32px 0'} boxShadow={2} gap={2} bgcolor={'white'}>
                    <Grid container item spacing={2} justifyContent="space-between" paddingRight={0}>
                        <Grid item lg={7} md={12} sm={12} xs={12}>
                            <Typography variant="h3" fontWeight={400}>
                                Estimate{' '}
                            </Typography>
                            <Stack direction="row" justifyContent={'flex-start'} gap={2} mt={1} sx={{ flexWrap: 'wrap' }}>
                                <DetailStatusChip status={DETAIL_STATUS.DRAFT} />
                            </Stack>
                        </Grid>
                        <Grid item>
                            <Stack spacing={0}>
                                <Typography variant="body1" fontWeight={500} fontSize={'24px'} align="right">
                                    {estimateData && estimateData?.estimateNumber}
                                </Typography>
                                <Typography variant="body1" fontWeight={400} sx={{ marginTop: '8px' }}>
                                    Service Advisor: {estimateData && (estimateData?.serviceAdvisor?.name || estimateData?.estimateCreatedBy)}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>
                    <Divider style={{ width: '100%', marginTop: '8px' }} />
                    {/* <Grid container item paddingRight={2}>
                        <Grid item>
                            <Stack>
                                <Typography variant="h6">{estimateData && estimateData?.shop?.shopName}</Typography>
                                <Typography variant="body1" fontWeight={400}>
                                    {estimateData &&
                                        estimateData?.shop?.address +
                                            ', ' +
                                            estimateData?.shop?.city?.city +
                                            ', ' +
                                            estimateData?.shop?.province?.province +
                                            ', ' +
                                            estimateData?.shop?.postalCode}
                                </Typography>
                                <Typography variant="body1" fontWeight={400}>
                                    {formatPhoneNumber(estimateData?.shop?.phoneNumber)}
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid> */}
                    <Grid container item justifyItems={'space-between'} paddingRight={0} style={{ marginTop: '8px' }}>
                        <DetailPageHeaderInfoColumns
                            documentType="estimate"
                            estimateDate={estimateData?.estimateDate}
                            customer={estimateData?.customer}
                            customerPO={estimateData?.customerPO}
                            vehicle={estimateData?.vehicle}
                            mileageUnit={mileageUnit}
                            estimateMileageOnly={estimateData?.odoDroppedOff == null && estimateData?.odoReturned == null}
                            odoDroppedOff={estimateData?.odoDroppedOff}
                            odoReturned={estimateData?.odoReturned}
                            mileageInDate={estimateData?.estimationExpiryDate}
                            mileageOutDate={estimateData?.completionDate}
                            estimateSingleOdo={estimateData?.odo}
                            estimateSingleOdoDate={estimateData?.completionDate || estimateData?.estimateDate}
                        />

                        {estimateData?.note && (
                            <Grid item xs={12} mt={3}>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        lineHeight: '150%',
                                        letterSpacing: '0.15px',
                                    }}
                                >
                                    Internal Shop Memo
                                </Typography>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.65)',
                                        marginTop: '8px',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '24px',
                                        letterSpacing: '0.15px',
                                    }}
                                >
                                    {estimateData?.note}
                                </Typography>
                            </Grid>
                        )}

                        {estimateData &&
                            estimateData?.services.map((item, index) => {
                                const serviceSubtotal = selectServiceSubtotal(item) ?? '0';

                                return (
                                    <>
                                        <Grid
                                            container
                                            item
                                            sx={{
                                                mt: '32px',
                                            }}
                                        >
                                            <Grid item xs={12}>
                                                <Typography
                                                    sx={{
                                                        px: '16px',
                                                        py: '12px',
                                                        bgcolor: 'secondary.main',
                                                        color: '#FFFFFF',
                                                        borderTopLeftRadius: '4px',
                                                        borderTopRightRadius: '4px',

                                                        fontSize: '20px',
                                                        fontWeight: 500,
                                                        lineHeight: '32px',
                                                        letterSpacing: '0.15px',
                                                    }}
                                                >
                                                    {item?.serviceName}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        {item?.pricingType == 'labor_&_parts' ? (
                                            <Grid container item>
                                                <Grid item xs={12}>
                                                    <TableContainer sx={{ maxHeight: 600 }}>
                                                        <Table
                                                            aria-label="estimate service table"
                                                            padding="16px"
                                                            sx={{
                                                                width: '100%',
                                                                tableLayout: 'fixed',

                                                                '& .MuiTableCell-root': {
                                                                    borderBottom: '1px solid rgba(0,0,0,0.12)',
                                                                    verticalAlign: 'middle',
                                                                    color: '#212121',
                                                                },
                                                            }}
                                                        >
                                                            <colgroup>
                                                                <col style={{ width: 56 }} />
                                                                <col />
                                                                <col style={{ width: 96 }} />
                                                                <col style={{ width: 90 }} />
                                                                <col style={{ width: 100 }} />
                                                                {showLineTax && <col style={{ width: 52 }} />}
                                                            </colgroup>

                                                            {/* Table Head */}
                                                            <TableHead
                                                                sx={{
                                                                    backgroundColor: '#F8F8F8',
                                                                    height: '40px',
                                                                    borderBottom: 'none',
                                                                }}
                                                            >
                                                                <TableRow
                                                                    sx={{
                                                                        height: '40px',
                                                                        borderBottom: 'none',
                                                                        '& > th, & > td': {
                                                                            px: '12px',
                                                                        },
                                                                    }}
                                                                >
                                                                    {/* NO */}
                                                                    <TableCell
                                                                        sx={{
                                                                            width: '56px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{
                                                                            padding: '6px 0 6px 16px',
                                                                        }}
                                                                    >
                                                                        No.
                                                                    </TableCell>

                                                                    {/* DESCRIPTION */}
                                                                    <TableCell
                                                                        sx={{
                                                                            padding: '6px 10px 6px 0',
                                                                        }}
                                                                        style={{
                                                                            height: '40px',
                                                                            paddingLeft: '0',
                                                                            paddingRight: '10px',
                                                                        }}
                                                                    >
                                                                        Description
                                                                    </TableCell>

                                                                    {/* QUANTITY */}
                                                                    <TableCell
                                                                        sx={{
                                                                            width: '96px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ padding: '0 10px' }}
                                                                    >
                                                                        Quantity
                                                                    </TableCell>

                                                                    {/* PRICE */}
                                                                    <TableCell
                                                                        sx={{
                                                                            width: '90px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ padding: '0 10px' }}
                                                                    >
                                                                        Price
                                                                    </TableCell>

                                                                    {/* AMOUNT */}
                                                                    <TableCell
                                                                        align={showLineTax ? 'left' : 'right'}
                                                                        sx={{
                                                                            width: '100px',
                                                                            fontSize: '14px',
                                                                            borderBottom: 'none',
                                                                        }}
                                                                        style={{ padding: '0 10px' }}
                                                                    >
                                                                        Amount
                                                                    </TableCell>

                                                                    {/* TAX */}
                                                                    {showLineTax && (
                                                                        <TableCell
                                                                            align="center"
                                                                            sx={{
                                                                                width: '52px',
                                                                                fontSize: '14px',
                                                                                paddingTop: '0',
                                                                                paddingBottom: '0',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ paddingRight: '16px', paddingLeft: '10px' }}
                                                                        >
                                                                            Tax
                                                                        </TableCell>
                                                                    )}
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {/* DESCRIPTION ROW */}
                                                                {item?.description?.trim() && (
                                                                    <TableRow key={item?.labor?.qty}>
                                                                        <TableCell
                                                                            style={{
                                                                                paddingLeft: '6px 0 6px 16px',
                                                                            }}
                                                                        />

                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px 6px 0',
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontSize: '16px',
                                                                                    fontWeight: 400,
                                                                                    lineHeight: '143%',
                                                                                    color: '#212121',
                                                                                }}
                                                                            >
                                                                                {item?.description}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        <TableCell style={{ padding: '6px 10px' }} />
                                                                        <TableCell style={{ padding: '6px 10px' }} />
                                                                        <TableCell style={{ padding: '6px 10px' }} />
                                                                        {showLineTax && <TableCell style={{ padding: '6px 16px 6px 10px' }} />}
                                                                    </TableRow>
                                                                )}

                                                                {/* LABOUR ROW */}
                                                                {item?.labor && item?.labor?.qty > 0 && (
                                                                    <TableRow key={item.no}>
                                                                        <TableCell
                                                                            style={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        >
                                                                            1
                                                                        </TableCell>

                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px 6px 0',
                                                                            }}
                                                                        >
                                                                            <Typography
                                                                                sx={{
                                                                                    fontSize: '16px',
                                                                                    fontWeight: 400,
                                                                                    lineHeight: '143%',
                                                                                }}
                                                                            >
                                                                                Labour
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {/* QUANTITY */}
                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            {item?.labor?.qty}
                                                                        </TableCell>

                                                                        {/* PRICE */}
                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            {item?.labor?.ratePerHour
                                                                                ? NumericEngine.format(item?.labor?.ratePerHour || 0, {
                                                                                      formatCurrency: true,
                                                                                      trailingZeros: true,
                                                                                  })
                                                                                : '$0.00'}
                                                                        </TableCell>

                                                                        {/* AMOUNT */}
                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            <Typography fontWeight={400} fontSize={16}>
                                                                                {item?.labor?.totalAmount
                                                                                    ? NumericEngine.format(item?.labor?.totalAmount || 0, {
                                                                                          formatCurrency: true,
                                                                                          trailingZeros: true,
                                                                                      })
                                                                                    : '$0.00'}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {/* TAX */}
                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                align="center"
                                                                                style={{
                                                                                    padding: '6px 16px 6px 8px',
                                                                                    fontSize: '16px',
                                                                                }}
                                                                            >
                                                                                <LineTaxCell
                                                                                    taxesBreakdown={item?.labor?.taxesBreakdown}
                                                                                    lineAmount={item?.labor?.totalAmount}
                                                                                    documentType={DOCUMENT_TAX_TYPE.ESTIMATE}
                                                                                    shopTaxesData={shopTaxesData}
                                                                                    provinceTaxGroup={provinceTaxGroup}
                                                                                    documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                    kind={LINE_TAX_KIND.LABOUR}
                                                                                    editable={false}
                                                                                    discount={estimateData?.discount}
                                                                                    subTotal={estimateData?.subTotal}
                                                                                />
                                                                            </TableCell>
                                                                        )}
                                                                    </TableRow>
                                                                )}

                                                                {item?.parts &&
                                                                    item?.parts?.length > 0 &&
                                                                    item?.parts.map((row, index) => {
                                                                        // A managed part's per-unit fee is billed on its own row, exactly as on an invoice.
                                                                        const showFeeCell = row?.fee?.name && row.feeAmount > 0;
                                                                        return (
                                                                            <Fragment key={row?._id || index}>
                                                                                <TableRow>
                                                                                    {/* NO */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 0 6px 16px',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: 400,
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        {index + (item?.fixedPrice > 0 || item?.labor?.qty > 0 ? 2 : 1)}
                                                                                    </TableCell>

                                                                                    {/* DESCRIPTION */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 10px 6px 0',
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        <Box>
                                                                                            {/* Managed parts open their inventory record, exactly as on an invoice. */}
                                                                                            <Typography
                                                                                                sx={{
                                                                                                    color: 'rgba(0, 0, 0, 0.87)',
                                                                                                    fontSize: '16px',
                                                                                                    fontWeight: 400,
                                                                                                    letterSpacing: '0.17px',
                                                                                                    lineHeight: '143%',
                                                                                                    textDecoration:
                                                                                                        row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                            ? 'none'
                                                                                                            : 'underline',
                                                                                                    cursor:
                                                                                                        row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED
                                                                                                            ? 'default'
                                                                                                            : 'pointer',
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    if (row.inventoryType === INVENTORY_MANAGE_TYPE.UNMANAGED) {
                                                                                                        return;
                                                                                                    }
                                                                                                    setSelectedInventoryId(
                                                                                                        row?.inventoryId || row?.inventory?._id
                                                                                                    );
                                                                                                    setInventoryOption(row);
                                                                                                    if (row?.inventoryBatches?.length > 1) {
                                                                                                        setBatchSelectionModal(true);
                                                                                                    } else if (
                                                                                                        row?.inventoryBatches?.length > 0 &&
                                                                                                        row?.inventoryBatches[0]?.batchNumber
                                                                                                    ) {
                                                                                                        setBatchNumber(
                                                                                                            row?.inventoryBatches[0]?.batchNumber ||
                                                                                                                row.batchNumber[0]
                                                                                                        );
                                                                                                        setOpenpartModel(true);
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                {row?.partName || row?.inventory?.part?.partName}
                                                                                            </Typography>

                                                                                            <Stack
                                                                                                direction="row"
                                                                                                spacing={1.25}
                                                                                                divider={
                                                                                                    <Box
                                                                                                        sx={{
                                                                                                            width: '1px',
                                                                                                            height: '16px',
                                                                                                            bgcolor: 'rgba(0, 0, 0, 0.12)',
                                                                                                        }}
                                                                                                    />
                                                                                                }
                                                                                            >
                                                                                                {(row?.partNumber || row?.tyreDimension) && (
                                                                                                    <Stack
                                                                                                        direction="row"
                                                                                                        alignItems="center"
                                                                                                        spacing={0.5}
                                                                                                        mt={'4px'}
                                                                                                    >
                                                                                                        <Typography
                                                                                                            component="span"
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: '#006CDD',
                                                                                                            }}
                                                                                                        >
                                                                                                            #
                                                                                                        </Typography>
                                                                                                        <Typography
                                                                                                            component="span"
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* partsType is not always returned; fall back to whichever identifier the part carries. */}
                                                                                                            {(row?.part?.partsType ?? row?.partsType) ===
                                                                                                            PART_TYPES.TYRE
                                                                                                                ? row?.tyreDimension || row?.partNumber
                                                                                                                : row?.partNumber || row?.tyreDimension}
                                                                                                        </Typography>
                                                                                                    </Stack>
                                                                                                )}

                                                                                                {row?.supplier?.name && (
                                                                                                    <Stack direction="row" alignItems="center" spacing={0.75}>
                                                                                                        <PartBrandSvg />
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {row.supplier.name}
                                                                                                        </Typography>
                                                                                                    </Stack>
                                                                                                )}

                                                                                                {row?.partsBrand?.name && (
                                                                                                    <Stack direction="row" alignItems="center" spacing={0.75}>
                                                                                                        <PartCategorySvg />
                                                                                                        <Typography
                                                                                                            sx={{
                                                                                                                fontSize: '16px',
                                                                                                                fontWeight: 400,
                                                                                                                letterSpacing: '0.17px',
                                                                                                                color: 'rgba(0, 0, 0, 0.87)',
                                                                                                            }}
                                                                                                        >
                                                                                                            {row.partsBrand.name}
                                                                                                        </Typography>
                                                                                                    </Stack>
                                                                                                )}
                                                                                            </Stack>
                                                                                        </Box>
                                                                                    </TableCell>

                                                                                    {/* QUANTITY */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 10px',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: 400,
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        {row?.totalQty ?? row?.qty}
                                                                                    </TableCell>

                                                                                    {/* PRICE */}
                                                                                    <TableCell
                                                                                        style={{
                                                                                            padding: '6px 10px',
                                                                                            fontSize: '16px',
                                                                                            fontWeight: 400,
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        {row?.cost
                                                                                            ? NumericEngine.format(row?.cost || 0, {
                                                                                                  formatCurrency: true,
                                                                                                  trailingZeros: true,
                                                                                              })
                                                                                            : '$0.00'}
                                                                                    </TableCell>

                                                                                    {/* AMOUNT */}
                                                                                    <TableCell
                                                                                        align={showLineTax ? 'left' : 'right'}
                                                                                        style={{
                                                                                            padding: '6px 10px',
                                                                                            fontSize: '16px',
                                                                                            borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                        }}
                                                                                    >
                                                                                        <Typography fontWeight={400} fontSize={16}>
                                                                                            {row?.totalAmount
                                                                                                ? NumericEngine.format(row?.totalAmount || 0, {
                                                                                                      formatCurrency: true,
                                                                                                      trailingZeros: true,
                                                                                                  })
                                                                                                : '$0.00'}
                                                                                        </Typography>
                                                                                    </TableCell>

                                                                                    {/* TAX */}
                                                                                    {showLineTax && (
                                                                                        <TableCell
                                                                                            align="center"
                                                                                            style={{
                                                                                                padding: '6px 16px 6px 10px',
                                                                                                fontSize: '16px',
                                                                                                borderBottom: row?.lastDescription || showFeeCell ? 'none' : '',
                                                                                            }}
                                                                                        >
                                                                                            <LineTaxCell
                                                                                                taxesBreakdown={row?.taxesBreakdown}
                                                                                                lineAmount={recordPartGrossAmount(row)}
                                                                                                documentType={DOCUMENT_TAX_TYPE.ESTIMATE}
                                                                                                shopTaxesData={shopTaxesData}
                                                                                                provinceTaxGroup={provinceTaxGroup}
                                                                                                documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                                kind={LINE_TAX_KIND.PARTS}
                                                                                                editable={false}
                                                                                                discount={estimateData?.discount}
                                                                                                subTotal={estimateData?.subTotal}
                                                                                            />
                                                                                        </TableCell>
                                                                                    )}
                                                                                </TableRow>

                                                                                {row?.lastDescription && (
                                                                                    <TableRow>
                                                                                        <TableCell
                                                                                            style={{
                                                                                                padding: '0 12px 6px 16px',
                                                                                                borderBottom: showFeeCell ? 'none' : undefined,
                                                                                            }}
                                                                                        />
                                                                                        <TableCell
                                                                                            colSpan={3}
                                                                                            style={{
                                                                                                padding: '0 12px 6px 0',
                                                                                                borderBottom: showFeeCell ? 'none' : undefined,
                                                                                            }}
                                                                                        >
                                                                                            <Typography
                                                                                                sx={{
                                                                                                    fontSize: '14px',
                                                                                                    fontWeight: 400,
                                                                                                    lineHeight: '20px',
                                                                                                    letterSpacing: '0.4px',
                                                                                                    color: '#848484',
                                                                                                }}
                                                                                            >
                                                                                                {row?.lastDescription}
                                                                                            </Typography>
                                                                                        </TableCell>
                                                                                        {showLineTax && (
                                                                                            <TableCell
                                                                                                style={{
                                                                                                    paddingTop: 0,
                                                                                                    borderBottom: showFeeCell ? 'none' : undefined,
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </TableRow>
                                                                                )}

                                                                                {showFeeCell && (
                                                                                    <TableRow>
                                                                                        <TableCell style={{ padding: '0 12px 6px 16px', fontSize: '16px' }} />
                                                                                        <TableCell style={{ padding: '0 12px 6px 0', fontSize: '16px' }}>
                                                                                            {row?.fee?.name}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ padding: '0 12px', fontSize: '16px' }}>
                                                                                            {row?.totalQty ?? row?.qty}
                                                                                        </TableCell>
                                                                                        <TableCell style={{ padding: '0 12px', fontSize: '16px' }}>
                                                                                            {NumericEngine.format(row?.feeAmount || 0, {
                                                                                                formatCurrency: true,
                                                                                                trailingZeros: true,
                                                                                            })}
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            align={showLineTax ? 'left' : 'right'}
                                                                                            style={{ padding: '0 12px', fontSize: '16px' }}
                                                                                        >
                                                                                            {NumericEngine.format(
                                                                                                NumericEngine.multiply(
                                                                                                    row?.totalQty ?? row?.qty ?? 0,
                                                                                                    row?.feeAmount || 0
                                                                                                ),
                                                                                                {
                                                                                                    formatCurrency: true,
                                                                                                    trailingZeros: true,
                                                                                                }
                                                                                            )}
                                                                                        </TableCell>
                                                                                        {showLineTax && (
                                                                                            <TableCell style={{ padding: '0 16px 0 10px', fontSize: '16px' }} />
                                                                                        )}
                                                                                    </TableRow>
                                                                                )}
                                                                            </Fragment>
                                                                        );
                                                                    })}

                                                                {shouldShowPerServiceSubtotalRow(item, { variant: 'estimate-detail' }) && (
                                                                    <TableRow>
                                                                        <TableCell
                                                                            colSpan={4}
                                                                            style={{
                                                                                // borderBottom: 0,
                                                                                background: '#fff',
                                                                                padding: '6px 10px',
                                                                            }}
                                                                        />

                                                                        {/* TOTAL AMOUNT */}
                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            style={{
                                                                                // borderBottom: 0,
                                                                                background: '#fff',
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            <Typography fontWeight={400} fontSize={16}>
                                                                                {serviceSubtotal > 0
                                                                                    ? NumericEngine.format(serviceSubtotal, {
                                                                                          formatCurrency: true,
                                                                                          trailingZeros: true,
                                                                                      })
                                                                                    : '$0.00'}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                style={{
                                                                                    // borderBottom: 0,
                                                                                    background: '#fff',
                                                                                    padding: '6px 10px',
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <>
                                                <Grid container item>
                                                    <Grid item xs={12}>
                                                        <TableContainer sx={{ maxHeight: 600 }}>
                                                            <Table
                                                                aria-label="fixed price table"
                                                                padding="16px"
                                                                sx={{
                                                                    width: '100%',
                                                                    tableLayout: 'fixed',

                                                                    '& .MuiTableCell-root': {
                                                                        borderBottom: '1px solid rgba(0,0,0,0.12)',
                                                                        verticalAlign: 'middle',
                                                                        color: '#212121',
                                                                    },
                                                                }}
                                                            >
                                                                <colgroup>
                                                                    <col style={{ width: 56 }} />
                                                                    <col />
                                                                    <col style={{ width: 96 }} />
                                                                    <col style={{ width: 90 }} />
                                                                    <col style={{ width: 100 }} />
                                                                    {showLineTax && <col style={{ width: 56 }} />}
                                                                </colgroup>

                                                                {/* TABLE HEAD */}
                                                                <TableHead
                                                                    sx={{
                                                                        backgroundColor: '#F8F8F8',
                                                                        height: '40px',
                                                                        borderBottom: 'none',
                                                                    }}
                                                                >
                                                                    <TableRow
                                                                        sx={{
                                                                            height: '40px',
                                                                            borderBottom: 'none',
                                                                            '& > th, & > td': {
                                                                                px: '12px',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <TableCell
                                                                            sx={{
                                                                                width: '56px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        >
                                                                            No.
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                fontSize: '14px',
                                                                                padding: '6px 10px 6px 0',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{
                                                                                height: '40px',
                                                                            }}
                                                                        >
                                                                            Description
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                width: '96px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ padding: '0 10px' }}
                                                                        >
                                                                            Quantity
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                width: '90px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ padding: '0 10px' }}
                                                                        >
                                                                            Price
                                                                        </TableCell>

                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            sx={{
                                                                                width: '100px',
                                                                                fontSize: '14px',
                                                                                borderBottom: 'none',
                                                                            }}
                                                                            style={{ padding: '0 10px' }}
                                                                        >
                                                                            Amount
                                                                        </TableCell>

                                                                        {/* TAX */}
                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                align="center"
                                                                                sx={{
                                                                                    width: '80px',
                                                                                    fontSize: '14px',
                                                                                    paddingTop: '0',
                                                                                    paddingBottom: '0',
                                                                                    borderBottom: 'none',
                                                                                }}
                                                                                style={{ paddingRight: '16px' }}
                                                                            >
                                                                                Tax
                                                                            </TableCell>
                                                                        )}
                                                                    </TableRow>
                                                                </TableHead>

                                                                {/* TABLE BODY */}
                                                                <TableBody>
                                                                    <TableRow>
                                                                        <TableCell
                                                                            style={{
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                                padding: '6px 0 6px 16px',
                                                                            }}
                                                                        >
                                                                            1
                                                                        </TableCell>

                                                                        <TableCell
                                                                            style={{
                                                                                padding: '6px 10px 6px 0',
                                                                                fontSize: '16px',
                                                                                fontWeight: 400,
                                                                            }}
                                                                        >
                                                                            {item?.description || 'Fixed Price'}
                                                                        </TableCell>

                                                                        <TableCell style={{ padding: '6px 10px' }} />

                                                                        <TableCell style={{ padding: '6px 10px' }} />

                                                                        {/* AMOUNT */}
                                                                        <TableCell
                                                                            align={showLineTax ? 'left' : 'right'}
                                                                            style={{
                                                                                padding: '6px 10px',
                                                                                fontSize: '16px',
                                                                            }}
                                                                        >
                                                                            <Typography fontWeight={400} fontSize={16}>
                                                                                {item?.fixedPrice
                                                                                    ? NumericEngine.format(item?.fixedPrice || 0, {
                                                                                          formatCurrency: true,
                                                                                          trailingZeros: true,
                                                                                      })
                                                                                    : '$0.00'}
                                                                            </Typography>
                                                                        </TableCell>

                                                                        {/* TAX */}
                                                                        {showLineTax && (
                                                                            <TableCell
                                                                                align="center"
                                                                                style={{
                                                                                    padding: '6px 16px 6px 10px',
                                                                                    fontSize: '16px',
                                                                                }}
                                                                            >
                                                                                <LineTaxCell
                                                                                    taxesBreakdown={item?.taxesBreakdown}
                                                                                    lineAmount={item?.fixedPrice}
                                                                                    documentType={DOCUMENT_TAX_TYPE.ESTIMATE}
                                                                                    shopTaxesData={shopTaxesData}
                                                                                    provinceTaxGroup={provinceTaxGroup}
                                                                                    documentHasPartsOrPackages={documentHasPartsOrPackages}
                                                                                    kind={LINE_TAX_KIND.PACKAGE}
                                                                                    editable={false}
                                                                                    discount={estimateData?.discount}
                                                                                    subTotal={estimateData?.subTotal}
                                                                                />
                                                                            </TableCell>
                                                                        )}
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )}
                                    </>
                                );
                            })}

                        {/* Fees Table  */}
                        {estimateData?.fees?.length > 0 && <EstimateFeesTable estimateData={estimateData} />}
                        {estimateData?.recommendationNotes && <InvoiceRecommandationSection invoiceData={estimateData} />}

                        <Grid container spacing={2} mt={'32px'} justifyContent={'space-between'} alignItems={'flex-start'}>
                            <Grid item xs={12} md={6} lg={6} xl={7}>
                                {estimateData?.termsAndWarranty?.title && estimateData?.termsAndWarranty?.description && (
                                    <EstimateTermsAndWarranty estimateData={estimateData} />
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} lg={6} xl={5}>
                                {/* Payment Details Table  */}

                                <EstimatePaymentDetails estimateData={estimateData} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

            <CommonDialog
                loader={deleteLoader}
                open={isDeleteModal}
                onClose={() => {
                    setIsDeleteModal(false);
                }}
                onSave={async () => {
                    setDeleteLoader(true);
                    const resp = await deleteFinalizedEstimate(estimateId);
                    if (resp) {
                        queryClient.invalidateQueries({ queryKey: estimateQueryKeys.all, refetchType: 'all' });
                        navigate('/estimates/all');
                    }
                    setIsDeleteModal(false);
                    setDeleteLoader(true);
                }}
                dialogTitle={'Delete Estimate?'}
                dialogSubtitle={`Are you sure you want to delete Estimate ${estimateData?.estimateNumber || ''}? This action cannot be undone.`}
            />

            {/* Read-only inventory record for a managed part — same modal as the invoice detail page. */}
            <AddInventoryModal
                type={INVENTORY_TYPES.INVOICE}
                showUsedInInvoiceFeild={true}
                FeildLabelName="Used in Estimate"
                isUsedInvoiceQty={inventoryOption?.totalQty}
                isUseLastCost={inventoryOption?.totalQty ? true : false}
                inventoryId={selectedInventoryId}
                batchNumber={batchNumber}
                viewOnly={true}
                openModal={openPartModel}
                closeModal={() => {
                    setOpenpartModel(false);
                    setInventoryOption(null);
                    setSelectedInventoryId(null);
                    setBatchNumber(null);
                }}
                onSubmitModal={() => {
                    setOpenpartModel(false);
                    setSelectedInventoryId(null);
                    setInventoryOption(null);
                    setBatchNumber(null);
                }}
                showLoader={false}
                setShowLoader={() => {}}
                selectedInventory={[]}
                setSelectedInventory={() => {}}
                fetchApi={() => {}}
                ShowAllTabs={false}
                ShowTabIndex={0}
                modalType={'edit'}
            />

            <SuccessMessageModal message={successMessage} open={openSuccessModal} setOpenSuccessModal={setOpenSuccessModal} />
            <Dialog open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default EstimateDraft;
